import useShopifyCollection from "@hooks/useShopifyCollection"
import { ContentfulProductWithShopifyData, ShopifyCollection } from "@lib/types"
import { useRouter } from "next/router"
import React, { useEffect, useState } from "react"
import ContentLoader, { List } from "react-content-loader"
import styled from "styled-components"
import { CollectionPage } from "."

const CollectionPageWrapper = ({ page }: any) => {
  const { slots } = page
  //console.log(page)
  const [productsToShow, setProductsToShow] = useState<
    ContentfulProductWithShopifyData[] | undefined
  >([])

  const [productSectionsCollection, setProductSectionsCollection] = useState()
  const { locale } = useRouter()
  const [showLoader, setShowLoader] = useState(false)

  const query = (collectionHandle: string) => `
  {
    product: collectionByHandle(handle: "${collectionHandle}"){
    products(first: 250){
      edges {
        node {
          id
          title
          handle
          productType
          tags
          contentfulData: metafield(namespace: "contentful", key: "product_data_${
            locale && locale.toLowerCase().replace("-", "_")
          }") {
            value
            key
            id
          }
          variants(first: 15){
            edges{
              node{
                title
                quantityAvailable
                price
                compareAtPrice
                id
                image {
                  originalSrc
                }
              }
            }
          }

        }
      }
      
    }
  }
}
  `

  const collectionRes: ContentfulProductWithShopifyData[] | undefined = useShopifyCollection(
    query(page.shopifyCollectionHandle),
    page.shopifyCollectionHandle,
    locale
  )
  useEffect(() => {
    if (collectionRes) {
      const uniqProducts: any = collectionRes
        .filter((it: ContentfulProductWithShopifyData) => it?.sys?.id)
        .filter(
          // @ts-ignore
          (v: ContentfulProductWithShopifyData, i: number, a: []) =>
            a.findIndex((t: ContentfulProductWithShopifyData) => t.sys.id === v.sys.id) === i
        )
        .filter(
          ({ hideFromSite, hideFromCollections }: ContentfulProductWithShopifyData) =>
            !hideFromSite && !hideFromCollections
        )
      //console.log("SET PRODUCTS TO SHOW", uniqProducts)
      setProductsToShow(uniqProducts)
    }
  }, [collectionRes, page])

  useEffect(() => {
    if (productsToShow && productsToShow.length > 0) {
      let index = 0
      const sectionsCollection = slots.map((num: number, i: number) => {
        const items = productsToShow.slice(index, index + num)
        const section = {
          ...page.layoutBuilderCollection.items[i],
          productsCollection: {
            items,
          },
        }
        index += num

        return section
      })
      //console.log("SET PRODUCTS SECTION COLLECTION", sectionsCollection)
      setProductSectionsCollection(sectionsCollection)
    }
  }, [productsToShow, page])

  useEffect(() => {
    // In case the collection is still managed from Contentful
    console.log(page.productsCollection.items)
    if (!page.shopifyCollectionHandle) {
      setProductsToShow([...page.productsCollection.items])
      setProductSectionsCollection(page.sectionsCollection)
    }
  }, [page])

  useEffect(() => {
    setTimeout(() => setShowLoader(true), 400)
  }, [])

  const backgroundColor = "#f9f7f5"
  const foregroundColor = "#f5f1ef"

  return (
    <>
      {productsToShow && productSectionsCollection ? (
        <CollectionPage
          page={page}
          products={productsToShow}
          productSectionsCollection={productSectionsCollection}
        />
      ) : (
        <Wrapper>
          <BackgroundColorDiv />
          {showLoader && (
            <>
              <Header>
                <ContentLoaderWrapper>
                  <ContentLoader
                    viewBox="0 0 220 90"
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="20" y="1" rx="4" ry="4" width="180" height="18" />
                    <rect x="0" y="30" rx="4" ry="4" width="220" height="10" />
                    <rect x="0" y="45" rx="4" ry="4" width="200" height="10" />
                    <rect x="0" y="60" rx="4" ry="4" width="220" height="10" />
                    <rect x="0" y="75" rx="4" ry="4" width="170" height="10" />
                  </ContentLoader>
                </ContentLoaderWrapper>
              </Header>
              <CardsLoaderContainer>
                {[0, 0, 0, 0].map((_, i) => (
                  <ContentLoaderCard key={i}>
                    <ContentLoader
                      viewBox="0 0 236 465"
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="4" ry="4" width="235" height="345" />
                      <rect x="20" y="365" rx="4" ry="4" width="200" height="22" />
                      <rect x="30" y="400" rx="4" ry="4" width="180" height="17" />
                    </ContentLoader>
                  </ContentLoaderCard>
                ))}
              </CardsLoaderContainer>
            </>
          )}
        </Wrapper>
      )}
    </>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
`

const BackgroundColorDiv = styled.div`
  background: ${({ theme }) => theme.color.beige};
  position: absolute;
  width: 100%;
  top: 0;
  height: 65rem;
  z-index: -1;
`

const Header = styled.div`
  display: flex;
  justify-content: center;
  padding: 3rem 0 12.1rem;
  width: 100%;
  height: @media (min-width: ${({ theme }) => theme.breakpoint.xl}px) {
    padding: 3rem 0 19.6rem;
  }
`

const ContentLoaderWrapper = styled.div`
  max-width: 60rem;
  height: 300px;
  padding: 0px 5rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
  }
  svg {
    width: 100%;
    height: 100%;
  }
`

const CardsLoaderContainer = styled.ul`
  display: grid;
  max-width: 76.8rem;
  margin: 0px 0px 4rem;
  margin-top: -80px;
  padding: 0px 1.6rem;
  grid-template-columns: repeat(auto-fill, calc(50% - 0.7rem));
  column-gap: 1.4rem;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    padding: 0 2rem;
    max-width: 110rem;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 2.6rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.xl}px) {
    padding: 0;
  }
`

const ContentLoaderCard = styled.div`
  margin: 0 0 2.4rem;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    margin: 0;
  }
`

export default CollectionPageWrapper
